/**
 * Local-storage twin of session-storage.util: JSON in, JSON out, and every failure (privacy modes,
 * quota, malformed data) is swallowed so callers get null instead of an exception.
 */
export const getLocalStorageItem = (key: string): unknown => {
  try {
    const storedData = localStorage.getItem(key);
    return storedData ? (JSON.parse(storedData) as unknown) : null;
  } catch {
    return null;
  }
};

export const setLocalStorageItem = (key: string, data: unknown): void => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch {
    console.error('Failed to store data in local storage');
  }
};
